/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { paginatedMobileOrderListSchema } from "./paginatedMobileOrderListSchema.ts";

export const orderListQueryDateFromSchema = z.iso.datetime().optional().describe("Дата создания заказа (от)");

export const orderListQueryDateToSchema = z.iso.datetime().optional().describe("Дата создания заказа (до)");

export const orderListQueryExternalIdSchema = z.uuid().optional();

export const orderListQueryIsActiveSchema = z.boolean().optional().describe("Активный заказ");

export const orderListQueryOrgUnitSchema = z.uuid().optional();

export const orderListQueryOrganizationSchema = z.uuid();

export const orderListQueryPageSchema = z.int().optional().describe("A page number within the paginated result set.");

export const orderListQueryPageSizeSchema = z.int().optional().describe("Number of results to return per page.");

export const orderListQueryStatusSchema = z
	.enum([
		"cancelled",
		"completed",
		"confirmed",
		"created",
		"failed",
		"failed_after_paid",
		"failed_after_payment_initiation",
		"failed_after_sent",
		"failed_after_sent_fiscalization",
		"failed_payment",
		"fake_fiscalized",
		"fiscalized",
		"paid",
		"partial_paid",
		"payment_initiation",
		"payment_initiation_retry",
		"refund_failed",
		"refunded",
		"sent",
		"sent_fiscalization",
		"waiting_creation_iiko",
		"waiting_deferred_payment",
		"waiting_for_fiscalization",
		"waiting_for_refund",
		"waiting_manual_action",
		"waiting_payment",
	])
	.optional()
	.describe(
		"* `created` - Создан локально\n* `waiting_payment` - Ожидает оплаты\n* `waiting_deferred_payment` - Ожидает отложенной оплаты\n* `partial_paid` - Частично оплачен\n* `paid` - Оплачен\n* `failed_payment` - Ошибка оплаты\n* `failed_after_paid` - Ошибка после оплаты\n* `waiting_creation_iiko` - Ожидает создания в iiko\n* `failed` - Ошибка\n* `sent` - Создан в iiko\n* `confirmed` - Подтвержден пользователем\n* `failed_after_sent` - Ошибка создания в iiko\n* `waiting_for_fiscalization` - Ожидает фискализации\n* `sent_fiscalization` - Отправлен на фискализацию\n* `failed_after_sent_fiscalization` - Ошибка после отправки на фискализацию\n* `fake_fiscalized` - Фейковая временная фискализация без явно отправки на фискализацию (для режимов PSN и DESTROYER)\n* `fiscalized` - Фискализирован, ожидает оплаты или отправки на инициализацию оплаты\n* `payment_initiation` - Инициирована оплата\n* `payment_initiation_retry` - Повторная инициация оплаты\n* `failed_after_payment_initiation` - Ошибка после инициации оплаты\n* `waiting_for_refund` - Ожидает возврата\n* `refunded` - Возвращен\n* `refund_failed` - Ошибка возврата\n* `waiting_manual_action` - Ожидает ручного действия персонала\n* `completed` - Заказ завершен\n* `cancelled` - Заказ отменен",
	);

export const orderListStatus200Schema = paginatedMobileOrderListSchema;

export const orderListResponseSchema = orderListStatus200Schema;
